__turbopack_context__.v({
  "locate_unauthorized": "LocateUnauthorized-module-scss-module__N2hY5W__locate_unauthorized",
  "locate_unauthorized__headline": "LocateUnauthorized-module-scss-module__N2hY5W__locate_unauthorized__headline",
  "locate_unauthorized__text": "LocateUnauthorized-module-scss-module__N2hY5W__locate_unauthorized__text",
});
